export const CREDIT_CARD_BACKGROUND_COLORS = {
  visa: "linear-gradient(270deg, #6A94DC 0%, #3869C7 100%)",
  american_express: "linear-gradient(-269deg, #33A0E4 3%, #007ECD 97%)",
  mastercard: "linear-gradient(270deg, #58585A 0%, #58585A 100%)"
}
